/* eslint-disable prefer-const */
/* eslint-disable no-empty */
/* eslint-disable no-extend-native */
/* eslint-disable func-names */
/* eslint-disable no-restricted-properties */
export {}
declare global {
  interface Number {
    add(...arg: Number[]): Number
    sub(...arg: Number[]): Number
    mul(...arg: Number[]): Number
    div(...arg: Number[]): Number
  }
}
// 加
Number.prototype.add = function (...arg: Number[]) {
  let r1
  let r2
  let m
  let result = Number(this)
  arg.forEach((value) => {
    try {
      r1 = result.toString().split('.')[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = value.toString().split('.')[1].length
    } catch (e) {
      r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2))
    result = Math.round(result * m + Number(value) * m) / m
  })
  return result
}
// 减
Number.prototype.sub = function (...arg: number[]) {
  let r1
  let r2
  let m
  let result = Number(this)
  arg.forEach((value) => {
    try {
      r1 = result.toString().split('.')[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = value.toString().split('.')[1].length
    } catch (e) {
      r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2))
    const n = r1 >= r2 ? r1 : r2
    result = Number((Math.round(result * m - value * m) / m).toFixed(n))
  })
  return result
}
// 乘
Number.prototype.mul = function (...arg: number[]) {
  let result = this
  arg.forEach((value) => {
    let m = 0
    const s1 = result.toString()
    const s2 = value.toString()
    try {
      m += s1.split('.')[1].length
    } catch (e) {}
    try {
      m += s2.split('.')[1].length
    } catch (e) {}
    result =
      (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) /
      Math.pow(10, m)
  })
  return result
}
// 除
Number.prototype.div = function (...arg: number[]) {
  let result = this
  arg.forEach((value) => {
    let t1 = 0
    let t2 = 0
    let r1
    let r2
    try {
      t1 = result.toString().split('.')[1].length
    } catch (e) {}
    try {
      t2 = value.toString().split('.')[1].length
    } catch (e) {}
    r1 = Number(result.toString().replace('.', ''))
    r2 = Number(value.toString().replace('.', ''))
    result = (r1 / r2) * Math.pow(10, t2 - t1)
  })
  return result
}
